// src/api/client.ts
//
// Cliente fetch para el backend de CiudadApp. Adjunta el access token,
// maneja respuestas { ok, data, error, message }.
// Para producción la BASE_URL apunta al dominio real; en dev a WAMP local.

import { useAuth } from '../stores/auth';

const BASE_URL =
  (import.meta.env.VITE_API_BASE as string | undefined) ??
  // Si la app vive en /inspector/ en el mismo dominio que la API, asumimos /api en la raíz
  (location.hostname === 'localhost' ? 'http://localhost/ciudadapp/api' : '/api');

export class ApiError extends Error {
  status: number;
  data: unknown;
  constructor(message: string, status: number, data: unknown) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

export async function api<T = unknown>(
  path: string,
  options: RequestInit & { auth?: boolean } = {}
): Promise<T> {
  const { auth = true, headers, ...rest } = options;
  const token = useAuth.getState().accessToken;

  const finalHeaders: Record<string, string> = {
    Accept: 'application/json',
    ...(headers as Record<string, string> | undefined),
  };
  if (!(rest.body instanceof FormData) && rest.body !== undefined) {
    finalHeaders['Content-Type'] = 'application/json';
  }
  if (auth && token) {
    finalHeaders['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(BASE_URL + path, {
    ...rest,
    headers: finalHeaders,
  });

  let json: any;
  try {
    json = await res.json();
  } catch {
    throw new ApiError('Respuesta inválida del servidor', res.status, null);
  }

  if (!res.ok || json.ok === false) {
    if (res.status === 401) {
      useAuth.getState().logout();
    }
    throw new ApiError(json.error || json.message || `HTTP ${res.status}`, res.status, json);
  }

  return json.data as T;
}

export function apiUrl(path: string): string {
  return BASE_URL + path;
}
